export default __webpack_public_path__ + "static/joinUsHeader-9f4df08048265e3c6e1955db8c7c828d.jpg";